/** Appends " Preview" to the production form toast text for admin preview modals. */
export function withPreviewToastSuffix(message: string): string {
    if (/\bpreview\b/i.test(message)) {
        return message;
    }

    return `${message} Preview`;
}

export const PREVIEW_TOASTS = {
    kickOffChangesSaved: withPreviewToastSuffix('Your changes have been saved successfully'),
    spqChangesSaved: withPreviewToastSuffix('Changes saved successfully!'),
    spqSaveAnswersFailed: withPreviewToastSuffix('Could not save your answers. Please try again.'),
    spqSaveComponentsFailed: withPreviewToastSuffix('Could not save components. Please try again.'),
    scoreCardCompleteRequiredFields: withPreviewToastSuffix(
        'Please complete all required fields before submitting.'
    ),
    scoreCardSubmitFailed: withPreviewToastSuffix('Could not submit scores. Please try again.')
} as const;
